/**
 * Created by Aleksandr on 29.09.2022.
 */

const PlingaPayments = function () {
    RestPayments.call(this, connector.PLINGA, {
        sdk: SdkManager.SDK_PLINGA
    });
};

PlingaPayments.prototype = Object.create(RestPayments.prototype);
PlingaPayments.prototype.constructor = PlingaPayments;

PlingaPayments.prototype.purchaseOpen = function (product, callback) {
    plingaRpc.purchasePackage(product.itemId, (data) => {
        if (data.paymentStatus === "paid") {
            const purchase = this.createPurchase(undefined, product, {
                packageName: data.packageName
            });

            callback(connector.CODE_SUCCEED, purchase);
        } else {
            this.bus.trigger("stream:error", `PlingaPayments.purchase productId:${product.productId} ${JSON.stringify(data)}`);

            callback(ERRORS.PURCHASE.UNKNOWN, undefined, { error: data.paymentStatus });
        }
    });
};

PlingaPayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.PLINGA);
};
